import React from 'react'
import ModalDeleteInfoContainer from './ModalDeleteInfoContainer'

const ModalDeleteInfo = props => <ModalDeleteInfoContainer {...props} />

export default ModalDeleteInfo
